export const readFileAsDataUrl = (file, maxKb = 500) =>
  new Promise((resolve, reject) => {
    if (!file) return resolve("");
    if (file.size > maxKb * 1024) return reject(new Error(`File too large. Max ${maxKb}KB.`));
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });

export const Empty = ({ children, testid }) => (
  <div data-testid={testid} className="rounded-2xl border border-dashed border-ink/25 py-14 text-center text-ink/65">{children}</div>
);

export const Pill = ({ tone = "neutral", children }) => {
  const tones = {
    neutral: "bg-paper-2 text-ink",
    green: "bg-emerald-100 text-emerald-800",
    amber: "bg-amber-100 text-amber-800",
    red: "bg-red-100 text-red-800",
  };
  return <span className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-semibold ${tones[tone]}`}>{children}</span>;
};
